export default __webpack_public_path__ + "static/hero-image-9-749b32e2a7d40a0e38254d0bc6530b9b.jpeg";